import { useContext, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Box, Flex, Button } from 'rebass/styled-components'
import styled, { keyframes } from 'styled-components'
import { OpenedConversationsContext } from '../contexts/openConversationsCounts'
import withSession from "../lib/withSession"


const Wrapper = styled(Flex)`
width: 100%;
height: 100%;
display: flex;
overflow: hidden;
`

const Phone = styled(Box)`
`

const Navigation = styled.div`
  width: 100%;
  background-color: #344f79;
  border-radius: 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    
  `
const Navigation__listn = styled.div`
  list-style: none;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0;
  padding: 0;
`
const Navigation__itemn = styled.div`
  perspective: 100px;
  flex: 1;
`

const Navigation__icon = styled.svg`
  transition: all 0.35s ease;
  will-change: opacity, transform, background-color;
`
const Navigation__text = styled.div`
  position: absolute;
  transform: translateY(60px) skewY(-20deg);
  transform-origin: left bottom;
  color: white;
  font-weight: 400;
  opacity: 0;
  transition: all 0.35s ease;
  will-change: opacity, transform, background-color;
  font-size: 10px;
`
const Navigation__link = styled.div`
  font-size: 12px;
  text-decoration: none;
  color: #c3cad6;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  /* height: 70px; */
  padding: 20px 10px;
  overflow: hidden;
  position: relative;
  outline: none;
  &::before {
  content: "";
  width: 4px;
  height: 4px;
  border-radius: 15px;
  background-color: #F6C89F;
  position: absolute;
  transform: translateY(60px) scale(0.4);
  transition: all 0.35s cubic-bezier(0, 0.51, 0, 0.99);
  opacity: 0;
}
&.active > ${Navigation__icon} {
  transform: translateY(-60px) rotateX(90deg) scale(0.4) skewY(-30deg);
  opacity: 0;
}
&.active > ${Navigation__text} {
  opacity: 1;
  transform: translateY(-3px) skewY(0deg);
}
&.active::before {
  transform: translateY(12px) scale(1);
  transition: all 0.35s cubic-bezier(0, 0.51, 0, 0.99) 0.2s;
  opacity: 1;
}
`

interface IMenuSelectorProps {
  route: string,
  alternativeRoutes?: Array<string>
}
const MenuSelector: React.FC<IMenuSelectorProps> = ({
  route,
  children,
  alternativeRoutes
}) => {
  const location = useLocation()
  const navigate = useNavigate()

  const goToPage = () => {
    navigate(route)
  }
  const isSelected = location && (location.pathname === route || (!!alternativeRoutes && alternativeRoutes.find(x => location.pathname.startsWith(x))))
  return <Navigation__link onClick={() => goToPage()} className={isSelected ? 'active' : ''}>
    {children}
  </Navigation__link>
}

const HamburgerMenuMobile = ({ isMinified, setIsMinified }: { isMinified: boolean, setIsMinified: (b: boolean) => void }) => {
  const a = useContext(OpenedConversationsContext)

  return <Wrapper >
    <OpenedConversationsContext.Consumer>
      {openedConversation => {
        return (
          <>
            <Phone flex={1}>
              <Navigation>
                <Navigation__listn>
                  <Navigation__itemn>
                    <MenuSelector route='/'>

                      <Navigation__icon width="18" height="18" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16.875 39.375H9.375C7.3125 39.375 5.625 37.6875 5.625 35.625V9.375C5.625 7.3125 7.3125 5.625 9.375 5.625H16.875C18.9375 5.625 20.625 7.3125 20.625 9.375V35.625C20.625 37.6875 18.9375 39.375 16.875 39.375ZM28.125 39.375H35.625C37.6875 39.375 39.375 37.6875 39.375 35.625V26.25C39.375 24.1875 37.6875 22.5 35.625 22.5H28.125C26.0625 22.5 24.375 24.1875 24.375 26.25V35.625C24.375 37.6875 26.0625 39.375 28.125 39.375ZM39.375 15V9.375C39.375 7.3125 37.6875 5.625 35.625 5.625H28.125C26.0625 5.625 24.375 7.3125 24.375 9.375V15C24.375 17.0625 26.0625 18.75 28.125 18.75H35.625C37.6875 18.75 39.375 17.0625 39.375 15Z" fill="white" />
                      </Navigation__icon>
                      <Navigation__text>Dashboard</Navigation__text>
                    </MenuSelector>
                  </Navigation__itemn>

                  <Navigation__itemn>
                    <MenuSelector route='/patients' alternativeRoutes={['/patient/']}>
                      <Navigation__icon width="18" height="18" viewBox="0 0 30 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.85728 16.4286L16.2144 16.4298C16.8269 16.4299 17.4167 16.6614 17.8658 17.078C18.3148 17.4946 18.5898 18.0654 18.6357 18.6762L18.643 18.8584V21.8929C18.6418 26.9929 13.4374 28.5714 9.53585 28.5714C5.71207 28.5714 0.636354 27.056 0.434783 22.194L0.428711 21.8929V18.8571C0.428823 18.2446 0.660362 17.6548 1.07694 17.2058C1.49352 16.7568 2.06437 16.4818 2.67514 16.4359L2.85728 16.4286ZM18.9101 16.4298L27.143 16.4286C27.7555 16.4287 28.3453 16.6602 28.7943 17.0768C29.2433 17.4934 29.5183 18.0642 29.5643 18.675L29.5716 18.8571V21.2857C29.5704 25.8502 25.4066 27.3571 22.2859 27.3571C21.0011 27.3571 19.5428 27.0961 18.2678 26.4768C19.1809 25.3912 19.7735 24.0094 19.8488 22.2705L19.8573 21.8929V18.8584C19.8573 18.0059 19.5549 17.2312 19.0631 16.6119L18.9101 16.4286H27.143L18.9101 16.4298ZM9.53585 0.642853C10.413 0.642933 11.2815 0.815773 12.0918 1.15151C12.9021 1.48724 13.6384 1.97929 14.2586 2.59957C14.8787 3.21984 15.3706 3.9562 15.7062 4.76658C16.0418 5.57697 16.2145 6.44552 16.2144 7.32264C16.2143 8.19976 16.0415 9.06828 15.7058 9.8786C15.37 10.6889 14.878 11.4252 14.2577 12.0454C13.6374 12.6655 12.9011 13.1574 12.0907 13.493C11.2803 13.8286 10.4118 14.0013 9.53464 14.0012C7.76321 14.001 6.0644 13.2972 4.81192 12.0445C3.55945 10.7918 2.85591 9.09285 2.85607 7.32142C2.85623 5.55 3.56008 3.85119 4.81278 2.59871C6.06549 1.34623 7.76443 0.642692 9.53585 0.642853ZM22.893 3.07142C23.6106 3.07142 24.3211 3.21276 24.9841 3.48737C25.647 3.76197 26.2494 4.16447 26.7568 4.67188C27.2642 5.17928 27.6667 5.78166 27.9413 6.44462C28.2159 7.10758 28.3573 7.81813 28.3573 8.53571C28.3573 9.25329 28.2159 9.96384 27.9413 10.6268C27.6667 11.2898 27.2642 11.8921 26.7568 12.3995C26.2494 12.9069 25.647 13.3094 24.9841 13.5841C24.3211 13.8587 23.6106 14 22.893 14C21.4438 14 20.0539 13.4243 19.0292 12.3995C18.0044 11.3748 17.4287 9.98493 17.4287 8.53571C17.4287 7.08649 18.0044 5.69663 19.0292 4.67188C20.0539 3.64712 21.4438 3.07142 22.893 3.07142Z" fill="white" />
                      </Navigation__icon>
                      <Navigation__text>Patients</Navigation__text>
                    </MenuSelector>
                  </Navigation__itemn>

                  <Navigation__itemn>
                    <MenuSelector route='/messages' alternativeRoutes={['/messages/']}>
                      <Navigation__icon width="18" height="18" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.54166 27.3053C7.35022 27.4718 7.11526 27.5802 6.86437 27.6178C6.61348 27.6554 6.35707 27.6206 6.12524 27.5176C5.89342 27.4146 5.6958 27.2475 5.55558 27.0361C5.41537 26.8247 5.33838 26.5776 5.33366 26.324V23.3333C4.62641 23.3333 3.94814 23.0524 3.44804 22.5523C2.94794 22.0522 2.66699 21.3739 2.66699 20.6667V11.3333C2.66699 10.6261 2.94794 9.94781 3.44804 9.44771C3.94814 8.94761 4.62641 8.66666 5.33366 8.66666H20.0003C20.7076 8.66666 21.3858 8.94761 21.8859 9.44771C22.386 9.94781 22.667 10.6261 22.667 11.3333V20.6667C22.667 21.3739 22.386 22.0522 21.8859 22.5523C21.3858 23.0524 20.7076 23.3333 20.0003 23.3333H13.3377L7.54166 27.3053ZM24.0003 16.6893C23.9961 16.8533 23.9961 17.0174 24.0003 17.1813V16.688C24.007 16.5453 24.0083 14.7587 24.0057 11.3293C24.0046 10.2692 23.5827 9.25277 22.8327 8.50349C22.0826 7.75421 21.0658 7.33333 20.0057 7.33333H9.33366V5.99999C9.33366 5.29275 9.61461 4.61447 10.1147 4.11438C10.6148 3.61428 11.2931 3.33333 12.0003 3.33333H26.667C27.3742 3.33333 28.0525 3.61428 28.5526 4.11438C29.0527 4.61447 29.3337 5.29275 29.3337 5.99999V15.3333C29.3337 16.0406 29.0527 16.7188 28.5526 17.2189C28.0525 17.719 27.3742 18 26.667 18V20.9907C26.6623 21.2443 26.5853 21.4913 26.4451 21.7028C26.3049 21.9142 26.1072 22.0812 25.8754 22.1843C25.6436 22.2873 25.3872 22.3221 25.1363 22.2845C24.8854 22.2469 24.6504 22.1385 24.459 21.972L24.0003 21.6573V16.6893Z" fill="white" />
                      </Navigation__icon>
                      <Navigation__text>Messages</Navigation__text>
                    </MenuSelector>
                  </Navigation__itemn>
                  <Navigation__itemn>
                    <MenuSelector route='/resources' alternativeRoutes={['/resources/']}>
                      <Navigation__icon style={{ marginLeft: '5px', marginRight: '5px' }} width="18" height="18" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.15625 0C4.94279 0 4.73226 0.0496995 4.54133 0.145163C4.35041 0.240626 4.18433 0.37923 4.05625 0.55L0.1375 5.775C0.0482473 5.894 0 6.03875 0 6.1875L0 20.625C0 20.9897 0.144866 21.3394 0.402728 21.5973C0.660591 21.8551 1.01033 22 1.375 22H20.625C20.9897 22 21.3394 21.8551 21.5973 21.5973C21.8551 21.3394 22 20.9897 22 20.625V6.1875C22 6.03875 21.9518 5.894 21.8625 5.775L17.9438 0.55C17.8157 0.37923 17.6496 0.240626 17.4587 0.145163C17.2677 0.0496995 17.0572 0 16.8438 0L5.15625 0ZM11.6875 5.5H19.9375L20.625 6.41712V6.875H1.375V6.41712L2.0625 5.5H10.3125V1.375H11.6875V5.5ZM11 10.9904C13.288 8.63775 19.0094 12.7545 11 18.0469C2.99063 12.7531 8.712 8.63775 11 10.9904Z" fill="white" />
                      </Navigation__icon>
                      <Navigation__text>Resources</Navigation__text>
                    </MenuSelector>
                  </Navigation__itemn>

                  <Navigation__itemn>
                    <MenuSelector route='/settings' >
                      <Navigation__icon style={{ marginLeft: '5px', marginRight: '5px' }} width="18" height="18" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M33.5353 29.8281C32.7984 28.0827 31.729 26.4973 30.3868 25.1602C29.0487 23.8192 27.4635 22.75 25.7188 22.0117C25.7032 22.0039 25.6876 22 25.672 21.9922C28.1056 20.2344 29.6876 17.3711 29.6876 14.1406C29.6876 8.78906 25.3517 4.45312 20.0001 4.45312C14.6485 4.45312 10.3126 8.78906 10.3126 14.1406C10.3126 17.3711 11.8946 20.2344 14.3282 21.9961C14.3126 22.0039 14.297 22.0078 14.2813 22.0156C12.5313 22.7539 10.961 23.8125 9.61338 25.1641C8.2724 26.5022 7.20324 28.0874 6.46494 29.832C5.73964 31.5401 5.34846 33.3713 5.3126 35.2266C5.31156 35.2683 5.31887 35.3097 5.3341 35.3486C5.34934 35.3874 5.3722 35.4228 5.40132 35.4526C5.43044 35.4825 5.46524 35.5062 5.50368 35.5224C5.54211 35.5386 5.58339 35.5469 5.6251 35.5469H7.96885C8.14072 35.5469 8.27744 35.4102 8.28135 35.2422C8.35947 32.2266 9.57041 29.4023 11.711 27.2617C13.9259 25.0469 16.8673 23.8281 20.0001 23.8281C23.1329 23.8281 26.0743 25.0469 28.2892 27.2617C30.4298 29.4023 31.6407 32.2266 31.7188 35.2422C31.7228 35.4141 31.8595 35.5469 32.0313 35.5469H34.3751C34.4168 35.5469 34.4581 35.5386 34.4965 35.5224C34.535 35.5062 34.5698 35.4825 34.5989 35.4526C34.628 35.4228 34.6509 35.3874 34.6661 35.3486C34.6813 35.3097 34.6886 35.2683 34.6876 35.2266C34.6485 33.3594 34.2618 31.543 33.5353 29.8281ZM20.0001 20.8594C18.2071 20.8594 16.5196 20.1602 15.2501 18.8906C13.9806 17.6211 13.2813 15.9336 13.2813 14.1406C13.2813 12.3477 13.9806 10.6602 15.2501 9.39062C16.5196 8.12109 18.2071 7.42188 20.0001 7.42188C21.7931 7.42188 23.4806 8.12109 24.7501 9.39062C26.0196 10.6602 26.7188 12.3477 26.7188 14.1406C26.7188 15.9336 26.0196 17.6211 24.7501 18.8906C23.4806 20.1602 21.7931 20.8594 20.0001 20.8594Z" fill="white" />
                      </Navigation__icon>
                      <Navigation__text>Settings</Navigation__text>
                    </MenuSelector>
                  </Navigation__itemn>

                </Navigation__listn>
              </Navigation>
            </Phone>

          </>
        )
      }}
    </OpenedConversationsContext.Consumer>
  </Wrapper>
}

export default withSession(HamburgerMenuMobile)